import { AddFeature, Prefecture } from '@/domain/models/Store';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { StoreManagementStoreService } from '@/services/StoreManagement/AuthStores/StoreManagementStoreService';

export type StoreManagementSearchListParams = {
  limit: number;
  currentPage: number;
  name: string;
  /* NOTE 地域検索がなくなったのでコメントアウト */
  // prefectures: Prefecture[];
  // cities: string[];
};

export type StoreManagementSearchList = {
  id: number;
  name: string;
  email: string;
  phone_number: string;
  prefecture: Prefecture | '';
  city: string;
  street_address: string;
  building: string | null;
  zip_code: string;
  latitude: number | null;
  longitude: number | null;
  add_features: AddFeature[];
};

export type StoreManagementSearchListResponse = {
  count: number;
  auth_stores: StoreManagementSearchList[];
};

export const useStoreManagementAuthStoreSearchList = async (
  params: StoreManagementSearchListParams
): Promise<StoreManagementSearchListResponse> => {
  const storeManagementStoreService = new StoreManagementStoreService(
    getClient()
  );
  try {
    return await storeManagementStoreService.searchList(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
